export default "__VITE_ASSET__C9TwOT2T__"